import mapActions from "actions/map";
import BookShow from "components/shared/book/show";
import { connect, viewContainer } from "helpers/redux";
import React from "react";
import { config, initialState } from "../formConfig";
import Markup from "./markup";

class ShowItemChangePoint extends BookShow {
    get dropdActions() {
        const actions = [];
        const { canEditBooks } = this.props;
        if (canEditBooks) {
            actions.push({ text: "Удалить", action: this.actionClose });
        }
        return actions;
    }

    renderBody = () => {
        const { config } = this.props;
        return (
            <Markup
                {...config}
                renderGeopicker={this.renderGeopicker}
                renderField={this.renderField}
                Button={this.renderButton}
            />
        );
    };
}

const ConfiguredShow = (props) => <ShowItemChangePoint {...props} config={config} initialState={initialState} />;

const customDispatch = (dispatch) => {
    return {
        switchMap: (params) => dispatch(mapActions.switchMap(params)),
    };
};

const mapState = (_state) => ({});
const customConnect = (Component) => connect(mapState, customDispatch)(Component);

export default customConnect(viewContainer(ConfiguredShow, "item-change-points"));
